'use client';

import { FC, useRef } from 'react';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { useMediaQuery } from 'modules/mui/hooks';
import { isValidDate } from 'modules/stroyblok/services';
import { MarksWithImage } from 'commerce/storyblok/types';
import styles from './styles.module.css';

export const MarksBlock: FC<{ blok: MarksWithImage }> = ({ blok }) => {
  const { isMobile, isTablet, isDesktop } = useMediaQuery();
  const imageRef = useRef<HTMLImageElement>(null);

  const isDateValid = isValidDate(blok.startDate, blok.expirationDate);

  const mediaType = () => {
    if (isDesktop) {
      return 'desktop';
    }

    if (isMobile) {
      return 'mobile';
    }

    if (isTablet) {
      return 'tablet';
    }
  };

  const { asset, areas } = blok[mediaType() || 'desktop'];
  const { pathname } = new URL(asset.filename);

  return !asset.filename || !isDateValid ? null : (
    <div className={styles.root}>
      <Image
        src={asset.filename}
        className={styles.image}
        ref={imageRef}
        alt={pathname}
      />
      {areas?.map(({ id, x, y, width, height, unit, fieldValue }) =>
        !fieldValue || !fieldValue?.length ? null : (
          <Link
            key={id}
            href={fieldValue}
            className={styles.link}
            style={{
              top: `${y}${unit}`,
              left: `${x}${unit}`,
              width: `${width}${unit}`,
              height: `${height}${unit}`,
            }}
          ></Link>
        ),
      )}
    </div>
  );
};
